import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import propTypes from "prop-types";
import classNames from "classnames";
var regexProperties = {
  disableRegexPattern: null,
  allowedRegexExpression: null
};

var highlightKeywords = function highlightKeywords(getClassName, phrase, keyword) {
  var startIndex;
  var userQuery;
  var disableRegexPattern = regexProperties.disableRegexPattern,
      allowedRegexExpression = regexProperties.allowedRegexExpression;

  if (disableRegexPattern) {
    var regexToInclude = new RegExp(allowedRegexExpression, "g");
    userQuery = keyword.replace(regexToInclude, "");
  } else {
    userQuery = keyword;
  }

  try {
    startIndex = phrase.search(new RegExp(userQuery, "i"));
  } catch (error) {// we have removed return null because when any address with special characters(*120, (abc)) are searched from Address Validation Component then we were getting suggestion but on ui it was not visible beacuse inside catch it was returning null.
  }

  var endIndex = startIndex + userQuery.length;

  if (startIndex >= 0) {
    return /*#__PURE__*/React.createElement("span", null, phrase.slice(0, startIndex), /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "highlight"
      })
    }, phrase.slice(startIndex, endIndex)), phrase.slice(endIndex));
  }

  return /*#__PURE__*/React.createElement("span", null, phrase);
};

var TypeaheadItem = function TypeaheadItem(_ref) {
  var colorTheme = _ref.colorTheme,
      highlight = _ref.highlight,
      id = _ref.id,
      onClick = _ref.onClick,
      selected = _ref.selected,
      value = _ref.value,
      disableRegexPattern = _ref.disableRegexPattern,
      allowedRegexExpression = _ref.allowedRegexExpression;
  var getClassName = getClassNameFactory(TypeaheadItem.displayName); // added regex properties to a sperate object intead of passing to highlightKeywords functon to avoid warning issues : Only 3 parameters are allowed to a arrow function.

  regexProperties.disableRegexPattern = disableRegexPattern;
  regexProperties.allowedRegexExpression = allowedRegexExpression;
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      states: selected ? "selected" : "",
      modifiers: classNames({
        dark: colorTheme === "dark"
      })
    }),
    role: "option",
    "aria-selected": selected ? "true" : "false",
    id: id
  }, /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "button"
    }),
    onClick: onClick,
    type: "submit",
    value: value
  }, highlightKeywords(getClassName, value, highlight)));
};

TypeaheadItem.displayName = "SearchInputTypeaheadItem";
TypeaheadItem.propTypes = {
  colorTheme: propTypes.oneOf(["dark", "light"]),
  highlight: propTypes.string,
  id: propTypes.string,
  onClick: propTypes.func,
  selected: propTypes.bool,
  value: propTypes.string,
  disableRegexPattern: propTypes.bool,
  allowedRegexExpression: propTypes.string
};
TypeaheadItem.defaultProps = {
  colorTheme: "light"
};
export default TypeaheadItem;